export const ANSWERS_ON_QUESTIONS = [
  {
    title: 'Про подключение скидки',
    answers: [
      {
        title: 'Для каких объектов недвижимости можно подключить скидку на ипотеку?',
        answer: [
          'Подключение скидки на ипотеку доступно частным специалистам рынка и агентствам недвижимости только для квартир на вторичном рынке недвижимости размещенных на Циан вручную или с помощью XML-фида',
          'Кроме объектов, размещенных в Республиках Крым, Северная Осетия, Кабардино-Балкарская, Ингушетия, Карачаево-Черкесская, Калмыкия, Чеченская, Дагестан',
          'С 22 октября подключение опции Скидка на ипотеку будет доступно только для профессионалов по недвижимости с уровнями “Хороший агент”, “Надежный агент” и “Суперагент” в программе лояльности “Суперагенты”',
        ],
      },
      {
        title: 'Почему объект с подключенной скидкой получится продать быстрее?',
        answer: [
          'Помимо значка на объявлении мы добавим отдельный фильтр для поиска объектов недвижимости со скидкой на ипотеку, а также будем дополнительно привлекать внимание потенциальных покупателей к объявлениям со скидкой с помощью различных рекламных инструментов.',
        ],
      },
      {
        title: 'Как работает скидка на ипотеку с подключенным сервисом “Сотрудники”?',
        answer: [
          'Главный аккаунт агентства недвижимости может подключать/отключать к скидке на ипотеку объекты опубликованные за счет АН или за счет субаккаунта.',
          'Если служба контроля качества выявит факт нарушения условий на объекте главного аккаунта компании, то ограничение будет действовать только на объекты, размещенные на главном аккаунте и не будет распространятся на объекты субаккаунтов. ',
          'Если служба контроля качества выявит факт нарушения условий на объекте субаккаунта, то ограничение будет действовать только на объекты, размещенные на этом суббакаунте и не будет распространяться на остальные объекты агентства недвижимости.',
        ],
      },
    ],
  },
  {
    title: 'Про изменение цены',
    answers: [
      {
        title: 'Нужно ли снижать цену на 4,1% в объявлении?',
        answer: [
          'Нет. В случае если вы договорились с собственником о снижении стоимости объекта на 4,1%, то в объявлении должна остаться цена до скидки. ',
          'Стоимость объекта с учетом скидки должна отражаться в договоре аванса и ДКП.',
          'Например, стоимость вашего объекта недвижимости 10 000 000 рублей. Если собственник готов снизить стоимость на 4,1%, то цена в объявлении - 10 000 000 рублей, а в договоре аванса и ДКП - 9 590 000 рублей.',
        ],
      },
      {
        title: 'Можно ли изменять цену в объявлении после подключения скидки на ипотеку?',
        answer: [
          'Да, цену можно изменять как в большую, так и меньшую сторону.',
          'Например, стоимость вашего объекта недвижимости - 10 000 000 рублей. Вы подписали доп. соглашение о снижении стоимости до 9 500 000 рублей и изменили цену в объявлении. Если вы хотите сохранить возможность продать объект со скидкой на ипотеку, то собственник должен быть готов к дополнительному дисконту в 4,1%, но уже от новой стоимости объекта в 9 500 000 рублей.',
          'И наоборот, если вы приняли решение повысить стоимость недвижимости, например до 10 500 000 рублей, то скидка в 4,1% будет рассчитываться от этой цены. ',
        ],
      },
      {
        title: 'Можно ли умышленно завышать или занижать цену на объект недвижимости для получения значка?',
        answer: [
          'Нет. В случае выявления умышленного завышения или занижения стоимости объекта недвижимости для получения скидки на ипотеку, служба контроля качества Циан удалит объявление, в отношении которого было выявлено нарушение и отключит скидку от остальных объектов, если таковые имеются сроком на 1 мес.',
          'Например, скидка на ипотеку подключена к 10 вашим объектам недвижимости. Служба контроля качества выявила нарушение по одному из них. В этом случае мы удалим объявление с нарушением и отключим скидку на ипотеку для остальных 9-ти.',
          'В объявлении должна быть указана реальная цена недвижимости',
        ],
      },
    ],
  },
  {
    title: 'Про условия ипотечной программы',
    answers: [
      {
        title: 'Какие полные условия ипотечной программы?',
        answerType: 'list',
        answer: [
          'ПСК: 22,587% до 26,492%',
          'Базовая ставка: 25%',
          'Минимальный ПВ: 30%',
          'Скидка к ставке на 24 месяца: 4%',
          'Период действия льготной ставки: 24 месяца (2 года)',
          'Ставка после скидки с подтверждением дохода: 21%',
          'Банк: Банк ДОМ.РФ',
          'Скидка продавца: 4,1%',
          'Минимальный размер кредита: 500 тыс рублей',
          'Максимальный размер кредита: до 30 млн. руб. вкл. (до 50 млн. руб. вкл., если недвижимость находится в г. Москве, Московской обл., г. Санкт-Петербурге, Ленинградской обл)',
        ],
      },
      {
        title: 'Почему ставка только на 2 года?',
        answer: [
          'Мы предлагаем пониженную ставку, чтобы покупатель смог взять выгодную ипотеку сейчас, когда ставка на вторичку высокая. Он будет выплачивать ипотеку со сниженным процентом в течение 2 лет, а потом сможет рефинансировать её под те условия, которые будут актуальны на рынке',
        ],
      },
      {
        title: 'Какую скидку должен предоставить продавец для продажи квартиры со скидкой на ипотеку 4%?',
        answer: [
          'Для продажи квартиры со скидкой на ипотеку продавец должен предоставить скидку 4,1% на объект недвижимости',
        ],
      },
      {
        title: 'Фиксирован ли размер скидки?',
        answer: ['Да, размер скидки на объект недвижимости и скидки на ипотеку фиксированный'],
      },
      {
        title: 'Требуется ли какая-либо оплата со стороны продавца для подключения к программе?',
        answer: [
          'Оплачивать ничего не нужно. Продавец должен быть готов к снижению цены на квартиру и прописать сумму с учетом скидки в договоре аванса и ДКП',
        ],
      },
      {
        title: 'Как выглядит общая логика взаиморасчетов?',
        answer: [
          'Например, 10 000 000 рублей - изначальная стоимость вашего объекта недвижимости. 3 000 000 - первоначальный взнос (30%), 7 000 000 - размер кредита.',
          'Если продавец делает скидку 410 тыс. рублей (4,1%), то покупатель внесет первоначальный взнос 2,59 млн рублей. Комиссию банку из своего ПВ - 410 тыс. за снижение ставки и 7 млн кредит.',
        ],
      },
    ],
  },
  {
    title: 'Про выход на сделку',
    answers: [
      {
        title: 'Что происходит после того, как покупатель получит одобрение в банке?',
        answer: [
          'С вашим покупателем свяжется сотрудник из поддержки Циан проконсультирует по параметрам ипотеки и опции “Хочу свою ставку”, расскажет о программе и зафиксирует параметры кредита. Далее передаст заявку в банк.',
          'Вы должны будете прислать ДКП, правоустанавливающие и другие документы для одобрения объекта. Банк рассматривает объект. Если одобрит, то согласовывает дату сделки. Покупатель размещает ПВ и средства на оплату комиссии за снижение ставки на расчетном счете, который необходимо открыть в банке (если он не клиент Банка ДОМ.РФ).',
        ],
      },
    ],
  },
  {
    title: 'Про одобрение клиентов',
    answers: [
      {
        title: 'Если у клиента есть одобренная ипотека, доступна ли ему покупка квартиры по данной программе?',
        answer: [
          'Да, доступна. Для этого покупателю потребуется получить переодобрение по ссылке, которую вы отправите после того, как подключите скидку на ипотеку к объекту недвижимости',
        ],
      },
      {
        title:
          'Можно ли проводить сделку с покупателем не по этой программе, а по ипотеке в другом банке или за наличные, если я подключил скидку на ипотеку?',
        answer: [
          'Да, подключение скидки на ипотеку не обязывает вас проводить сделку по этой программе, если покупатель в ней не заинтересован',
        ],
      },
    ],
  },
];
